// features/council/filterCases.ts — pure, effect-free case-list selectors.
import type { CaseRecord, CaseStatus, ModerationCategory } from '@/core/models/case';

// A case awaiting a head moderator is pending in the strongest sense — nobody
// can even vote on it yet. Leaving it out would hide exactly the backlog the
// appointment step creates from the queue that exists to show it.
export function pendingCases(cases: CaseRecord[]): CaseRecord[] {
  return cases.filter(
    (c) =>
      c.status === 'under-review' ||
      c.status === 'appeal-review' ||
      c.status === 'awaiting-head',
  );
}
export function appealCases(cases: CaseRecord[]): CaseRecord[] {
  return cases.filter(
    (c) => c.status === 'decided' || c.status === 'appeal-review' || c.status === 'appeal-resolved',
  );
}
export function resolvedCases(cases: CaseRecord[]): CaseRecord[] {
  return cases.filter((c) => c.status === 'decided' || c.status === 'appeal-resolved');
}

export interface QueueFilter {
  category: ModerationCategory | 'all';
  status: CaseStatus | 'all';
  search: string;
}

export function filterQueue(cases: CaseRecord[], f: QueueFilter): CaseRecord[] {
  const q = f.search.trim().toLowerCase();
  return cases.filter((c) => {
    if (f.category !== 'all' && c.category !== f.category) return false;
    if (f.status !== 'all' && c.status !== f.status) return false;
    if (q) {
      const hay = `${c.reporter} ${c.team} ${c.postId ?? ''} ${c.accountId ?? ''}`.toLowerCase();
      if (!hay.includes(q)) return false;
    }
    return true;
  });
}
